import { Injectable } from '@angular/core';
import {
  GetViewsRequest,
  ViewResponseCollection,
  DeleteViewRequest,
  SaveViewRequest,
  ViewResponse,
  UpdateLastSeenViewRequest,
} from '../proto/generated/inv_view_service_pb';
import { View } from '../proto/generated/inv_view_message_pb';
import { UserModel, ViewResponseModel } from 'src/app/shared/models';
import { ViewServiceClient } from '../proto/generated/inv_view_service_pb_service';
import { Observable } from 'rxjs';
import { BaseGRRCService } from '../shared/services/base.service';

@Injectable({
  providedIn: 'root',
})
export class ViewsGRPCService extends BaseGRRCService<ViewServiceClient> {
  constructor() {
    super(ViewServiceClient);
      // this.client = new ViewServiceClient('https://groupmanagementui.devcloud.olameter.com/backend');

    this.getApplicationBEVersion()
      .then((data: any) => {})
      .catch((reason) => {
        this.showConnectionError('NOTIFICATIONS.SERVICES.VIEWS', reason);
      });
  }

  get(data: UserModel): Observable<ViewResponseModel[]> {
    const request = new GetViewsRequest();
    request.setUserName(data.name);
    request.setUserGroupsList(data.groupsList.map((e) => e.name));
    return this.withGrpcOptions((requestOptions) => {
      return new Observable<ViewResponseModel[]>((observer) => {
        this.client.get(
          request,
          requestOptions,
          (error, response: ViewResponseCollection) => {
            if (error) {
              this.handleError(error);
              observer.error(error);
            }
            if (response) {
              const viewResponse: Array<View> = response.getViewsList();

              const viewList: ViewResponseModel[] =
                ViewResponseModel.MapperList(viewResponse);
              observer.next(viewList);
              observer.complete();
            }
          }
        );
      });
    });
  }

  delete(name: string): Observable<void> {
    const request = new DeleteViewRequest();
    request.setName(name);
    return this.withGrpcOptions((requestOptions) => {
      return new Observable<void>((observer) => {
        this.client.delete(request, requestOptions, (error, response) => {
          if (error) {
            this.handleError(error);
            observer.error(error);
          }
          if (response) {
            observer.next();
            observer.complete();
          }
        });
      });
    });
  }

  save(view: ViewResponseModel): Observable<ViewResponseModel> {
    const request = ViewResponseModel.MapperToMessage(view);
    const viewRequest = new SaveViewRequest();
    viewRequest.setView(request);
    return this.withGrpcOptions((requestOptions) => {
      return new Observable<ViewResponseModel>((observer) => {
        this.client.save(
          viewRequest,
          requestOptions,
          (error, response: ViewResponse) => {
            if (error) {
              this.handleError(error);
              observer.error(error);
            }
            if (response) {
              const vP = response.getView();
              const view = ViewResponseModel.Mapper(vP);
              this.showTranslatedSuccess('NOTIFICATIONS.VIEWS.SAVED');
              observer.next(view);
              observer.complete();
            }
          }
        );
      });
    });
  }

  updateLastSeen(name: string): Observable<ViewResponseModel> {
    const request = new UpdateLastSeenViewRequest();
    request.setName(name);
    return this.withGrpcOptions((requestOptions) => {
      return new Observable<ViewResponseModel>((observer) => {
        this.client.updateLastSeen(
          request,
          requestOptions,
          (error, response: ViewResponse) => {
            if (error) {
              this.handleError(error);
              observer.error(error);
            }
            if (response) {
              const vP = response.getView();
              const view = ViewResponseModel.Mapper(vP);
              observer.next(view);
              observer.complete();
            }
          }
        );
      });
    });
  }
}
